import { Typography } from "@mui/material";
import { t } from "i18next";
import { useParams } from "react-router-dom";

import AsyncButton from "../../../../components/buttons/AsyncButton";
import CancelButton from "../../../../components/buttons/backButton/CancelButton";
import useTimeSlotsQuery from "../../../../hooks/graphql-hooks/queries/useTimeSlotsQuery";
import {
  TimeSlotFragment,
  TimeSlotsQueryVariables,
} from "../../../../models/autogenerated-deliveryService-gql/graphql";
import { IDeliveryItem } from "../../../../models/deliveryItem";
import { isNullOrEmpty } from "../../../../utils/helper";
import CheckBoxDeliveryItemList from "../../components/checkBoxDeliveryItemList/CheckBoxDeliveryItemList";
import "./SelectItems.scss";

interface SelectItemsProps {
  deliveryItems: IDeliveryItem[];
  selectedDeliveryItems: IDeliveryItem[];
  setSelectedDeliveryItems: (items: IDeliveryItem[]) => void;
  setTimeSlots: (timeSlots: TimeSlotFragment[] | null) => void;
}

const SelectItems = (props: SelectItemsProps) => {
  const { id: idFromUrl } = useParams();
  const {
    deliveryItems,
    selectedDeliveryItems,
    setSelectedDeliveryItems,
    setTimeSlots,
  } = props;

  const [timeSlotsQuery, { loading: loadingTimeSlots, error }] =
    useTimeSlotsQuery({
      dataAction: (timeSlots) => setTimeSlots(timeSlots),
    });

  const sendGetTimeSlotsQuery = () => {
    if (selectedDeliveryItems.length === 0 || isNullOrEmpty(idFromUrl)) return;

    const input: TimeSlotsQueryVariables = {
      timeSlotsInput: {
        inboundDeliveryId: idFromUrl,
        itemIds: selectedDeliveryItems.map((item) => item.id),
      },
    };

    timeSlotsQuery({ variables: input }).catch(() => {});
  };

  const onCheckBoxChange = () => {
    setTimeSlots(null);
  };

  return (
    <div className="page-content" data-testid="splitOrder">
      <div className="selectItems">
        <Typography className="selectItems-header" variant="h6">
          {t("selectItemsDescription")}
        </Typography>
        <CheckBoxDeliveryItemList
          items={deliveryItems}
          selectedItems={selectedDeliveryItems}
          setSelectedItems={setSelectedDeliveryItems}
          onCheckBoxChange={onCheckBoxChange}
        />
      </div>
      <div className="page-content-button-container">
        <div className="page-content-button-container-button-full-width">
          <AsyncButton
            sendRequest={sendGetTimeSlotsQuery}
            loading={loadingTimeSlots}
            disabled={selectedDeliveryItems.length === 0 || loadingTimeSlots}
            variant="contained"
          >
            {t("getTimeSlots")}
          </AsyncButton>
        </div>
        <div className="page-content-button-container page-content-button-container-button-center">
          <CancelButton />
        </div>
      </div>
    </div>
  );
};

export default SelectItems;
